import { useHistory } from 'react-router-dom';
import { GO_TO_ADD_NEW_PATIENT } from '../../routes/paths';
import { AntTooltip } from './AntTooltip';
import { SREV2 } from '../../api/pushGenie';
import { getAclViewClassName } from '../../restrictions/utils';
import { useEffect, useState } from 'react';
import { getItemFromMisc, MISC_KEYS } from '../../store/idbHandler';
import { BizSettings } from '../../api/fetchMyGenie';
import { getDefiniteMActiveId } from '../../store/localstorage';
import { Patient } from '../../store/types/patient';
import GlobalSearchModal from '../globalsearch/GlobalSearchModal';
import NewPatient, {
    FULL_GENDER_CHARS,
    Gender,
    NewPatientLocationState,
} from '../../pages/NewPatient';
import CreateABHAModalSDK from '../abha/CreateABHAModalSdk';
import { TProfileRecord } from '../../bridge/types';
import { notification } from 'antd';
import { track } from '../../tracking';

type Props = {
    clinicId: string;
    newDesign?: boolean;
};

const GoToAddPatientBt: React.FC<Props> = (props) => {
    const { clinicId } = props;
    const history = useHistory();

    const [searchAndAddPatient, setSearchAndAddPatient] = useState(false);
    const [selectedPatient, setSelectedPatient] = useState<Patient | undefined>();
    const [searchVisible, setSearchVisible] = useState(false);
    const [addPatientViaAbha, setAddPatientViaAbha] = useState<boolean>(false);
    const [newPatientDefaultState, setNewPatientDefaultState] = useState<
        NewPatientLocationState | undefined
    >(undefined);
    const [flow, setFlow] = useState<'create_abha_with_mobile' | 'login_with_abha'>(
        'create_abha_with_mobile',
    );

    useEffect(() => {
        getItemFromMisc<BizSettings>(getDefiniteMActiveId(), MISC_KEYS.bizSettings).then((res) => {
            setSearchAndAddPatient(res?.searchAndAddPatient);
        });
    }, []);

    const onAddPatient = () => {
        if (searchAndAddPatient) {
            setSearchVisible(true);
        } else {
            history.push(GO_TO_ADD_NEW_PATIENT(clinicId));
        }
    };

    const onAbhaAddPatientSuccess = (profile?: TProfileRecord) => {
        console.log('ABHA Patient Profile:', profile);
        if (!profile) {
            track('ERROR', {
                on: 'abha',
                what: 'add-patient',
                status: 'failed',
                message: 'Profile not found',
            });
            notification.error({
                message: 'Profile not found',
                duration: 5,
            });
            return;
        }

        history.push({
            pathname: GO_TO_ADD_NEW_PATIENT(clinicId),
            state: {
                name: profile.fln,
                phoneNumber: profile.mobile?.replace('+91', ''),
                gender: FULL_GENDER_CHARS[profile.gen || ''] as Gender,
                dob: profile.dob,
                defaultShowAbhaCard: true,
                defaultAbhaId: profile['health-ids']?.[0],
                defaultAbhaPtOid: profile.oid,
            },
        });
    };

    return (
        <AntTooltip content="Add Patient">
            {searchVisible && (
                <GlobalSearchModal
                    isGlobalSearchVisible={searchVisible}
                    close={() => setSearchVisible(false)}
                    onSelectPatient={(patient) => {
                        setSelectedPatient(patient);
                    }}
                    onAddPatientViaAbha={(
                        state: NewPatientLocationState,
                        flow?: 'create_abha_with_mobile' | 'login_with_abha',
                    ) => {
                        setAddPatientViaAbha(true);
                        setNewPatientDefaultState(state);
                        setFlow(flow || 'create_abha_with_mobile');
                    }}
                />
            )}

            {addPatientViaAbha && (
                <CreateABHAModalSDK
                    onClose={() => setAddPatientViaAbha(false)}
                    mobile={newPatientDefaultState?.phoneNumber}
                    onComplete={onAbhaAddPatientSuccess}
                    method={flow}
                />
            )}

            {selectedPatient && (
                <NewPatient
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    match={{ params: { cId: clinicId } }}
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    history={history}
                    patient={selectedPatient}
                    mode="actions"
                    closeMe={() => {
                        setSelectedPatient(undefined);
                        setSearchVisible(false);
                    }}
                />
            )}
            <button
                onClick={onAddPatient}
                className={`${
                    props.newDesign
                        ? 'h-36 px-16 btn-small rounded-8 bg-darwin-accent-bright-blue-800 text-white text-14 font-700'
                        : 'w-full py-10 primary-btn text-14'
                } ${getAclViewClassName(SREV2.PATIENT_REGISTRATION)}`}
            >
                <span className={`w-full text-center ${props.newDesign && 'text-13'}`}>
                    Add New Patient
                </span>
            </button>
        </AntTooltip>
    );
};

export default GoToAddPatientBt;
